<template>
    <main class="opacity-introjs">

        <section>

            <div class="content-960">
                <ul class="breadcrumb"></ul>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="row">
                        <div class="col-md-4" v-for="item in result.Totalizador">
                            <div class="card text-center">
                                <div class="card-header">
                                    {{item.nomeTotalizador}}
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title">{{item.valor}}</h5>
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </main>
</template>
<script>

    import base from '@/common/base.js'
    import auth from '@/common/auth'
    import TutorStep from '@/common/tutor-step'
    import { Api } from '@/common/api'

    export default {
        name: 'home',
        components: {},
        data() {
            return {
                resources: {
                    filter: 'escolabox',
                },
                filter: {},
                escolaLogadaId: 0,
                detectaMobile: false,
                result: {
                    total: 0,
                    totaisEscolas: 0,
                    Totalizador: "",
                }
            }
        },
        methods: {
            mobile() {
                if (navigator.userAgent.match(/Android/i)
                    || navigator.userAgent.match(/webOS/i)
                    || navigator.userAgent.match(/iPhone/i)
                    || navigator.userAgent.match(/iPad/i)
                    || navigator.userAgent.match(/iPod/i)
                    || navigator.userAgent.match(/BlackBerry/i)
                    || navigator.userAgent.match(/Windows Phone/i)
                ) {
                    this.detectaMobile = true;
                }
                else {
                    this.detectaMobile = false;
                }
            },
            TotalEscola: function () {
                this.filter.attributeBehavior = "TotaisEscolas";
                new Api('escolabox/totaisescolas').get(this.filter).then(data => {
                    this.result.Totalizador = data.dataList;
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            }
        },
        mounted() {
            this.mobile();
            this.TotalEscola();
            var user = auth.currentUser()
            if (user) this.escolaLogadaId = +user.tenant;
            TutorStep.start("/home");
        }
    };
</script>
